var render, staticRenderFns
import script from "./add_form_msg.vue?vue&type=script&lang=js&"
export * from "./add_form_msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1a7051e')) {
      api.createRecord('f1a7051e', component.options)
    } else {
      api.reload('f1a7051e', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/order/need_goods_config/components/add_form_msg.vue"
export default component.exports